module.exports = __webpack_public_path__ + "img/brain.4ab7cbfd.jpg";